const profile = {
  title: 'プロフィール',
  avatar: 'アバター',
  email: 'メールアドレス',
  email_teacher: 'メールアドレス',
  phone_number: '電話番号',
  password: 'パスワード',
  password_confirm: '確認パスワード',
  mentor: 'アートシフトコーチ',
  graduation_terms: '卒業期',
  kanji_name: '氏名（漢字）',
  first_name_kanji: '名',
  last_name_kanji: '姓',
  first_name_kanji_placeholder: '太郎',
  last_name_kanji_placeholder: '田中',
  name: '氏名（フリガナ）',
  first_name_placeholder: 'タロウ',
  last_name_placeholder: 'タナカ',
  first_name: 'メイ',
  last_name: 'セイ',
  date_of_birth: '生年月日',
  gender: '性別',
  time_zone: 'タイムゾーン ',
  post_code: '郵便番号',
  address: '住所',
  line_error: 'ライン内でエラーが発生しました',
  student_fail: '受講生を追加できませんでした。',
  coach_fail: 'アートシフトコーチを追加できませんでした。',
  student_success: '受講生を追加しました。',
  coach_success: 'アートシフトコーチを追加しました。',
  update_success: '更新に成功しました。',
  update_coach_success: 'アートシフトコーチのプロフィールを更新しました。',
  update_student_success: '受講生を更新しました。',
  password_hint: "パスワードには「半角英数字(大文字・小文字・数字)」「半角記号（!\"#$%&'()*+,-.\\/|:;<=>?@[]^_`{}~）」を含む8～32字で設定してください。",
  postcode_hint: '郵便番号には〒マーク(〒)、やハイフン(-)の入力は必要ありません。',
  phone_hint: '電話番号には数字のみ入力してください。\nハイフン(-)の入力は必要ありません。',
  student_limit: '受講生追加可能人数',
  student_limit_min: '受講生追加可能人数は10以上で入力してください。',
  student_limit_max: '受講生追加可能人数は1000以内で入力してください。',
  plan: 'プラン',
  plan_top_header: 'プラン変更',
  change_plan: {
    btn_submit: '変更',
    btn_cancel: 'キャンセル',
    plan_required: 'プランを入力してください。',
    upgrade_success: 'ご選択プランにアップグレードしました。',
    upgrade_fail: 'ご選択プランにアップグレードできません。',
    downgrade_success: 'ご選択プランにダウングレードしました。',
    downgrade_fail: 'ご選択プランにダウングレードできません。',
    cannot_downgrade_upgrade: '管理中の有効な受講生人数が、ご指定のプランの上限人数を超えていますため、プランの変更が失敗しました。適当な人数をご確認後、再度お試しください。',
    cannot_change_plan_when_wrong_time: "システムにより、料金の請求ができない状態となっておりますので、現在はアップグレードまたはダウングレードに失敗しました。10時以降に再度お試しください。"
  },
  register_card_success: '新しい支払い情報が登録されました。今後の決済はこのカードに請求されます。',
}

export default profile;